import React, { useState } from "react"
import { useFormContext } from "src/hooks/useForm"
import styled, { css } from "styled-components"
import { IconCircleEmpty, IconCheckCircle } from "@puregym/ui"

const Wrapper = styled.div<{ selected: boolean; hasFocus: boolean }>`
  width: 100%;
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors.primary.light : theme.colors.surface};
  border-radius: ${({ theme }) => theme.radii.double};
  margin-bottom: ${({ theme }) => theme.spacing.baseSpacing};
  border-width: 2px;
  border-style: solid;
  border-color: ${({ hasFocus, theme }) =>
    hasFocus ? theme.colors.opacities.invertedStrong : theme.colors.background};
`

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`

const Label = styled.label`
  display: block;
  padding: ${({ theme }) =>
    `${theme.spacing.halfSpacing} ${theme.spacing.baseSpacing}`};
  cursor: pointer;

  > span {
    margin-inline-start: ${({ theme }) => theme.spacing.baseSpacing};
    font-weight: bold;
  }
`

const iconStyles = css`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 50%;
  cursor: pointer;
`

const IconChecked = styled(IconCheckCircle)`
  ${iconStyles}
`

const IconUnchecked = styled(IconCircleEmpty)`
  ${iconStyles}
`

export const CheckBoxPanel: React.FC<{
  label: string
  name: string
}> = ({ label, name }) => {
  const { state, inputProps } = useFormContext()

  const value = state[name]

  const [hasFocus, setHasFocus] = useState(false)
  return (
    <Wrapper selected={value} hasFocus={hasFocus}>
      <Label>
        <Input
          name={name}
          type="checkbox"
          checked={value}
          {...inputProps}
          onFocus={() => setHasFocus(true)}
          onBlur={() => setHasFocus(false)}
        />
        {value ? (
          <IconChecked
            aria-hidden="true"
            focusable="false"
            style={{ fontSize: "3rem" }}
          />
        ) : (
          <IconUnchecked
            aria-hidden="true"
            focusable="false"
            style={{ fontSize: "3rem" }}
          />
        )}
        <span>{label}</span>
      </Label>
    </Wrapper>
  )
}
